export default "__VITE_ASSET__f3ef4b45__$_?component__"